import { isAxiosError } from 'axios'
import { FormattedMessage } from 'react-intl'
import { commonLang } from '@/shared/commonLang.ts'

export const processErrorResponse = (error: unknown) => {
  if (isAxiosError(error)) {
    if (error?.response?.data?.message) {
      return error?.response?.data?.message
    }
  }
  return <FormattedMessage {...commonLang.somethingWrong} />
}
